import { Column } from '../../../../../common/Table';
import { TeamMemberStats } from '../../../types/checkInStats';

interface CheckInData {
  count?: number;
  total?: number;
  // trend?: number;
  percentage?: number;
}

// function getTrendColor(trend: number): string {
//   if (trend > 0) return 'text-green-500';
//   if (trend < 0) return 'text-red-500';
//   return 'text-gray-500';
// }

// function getTrendIcon(trend: number): JSX.Element | null {
//   if (trend > 0)
//     return <Icon name="arrowup" className="h-4 w-4 text-green-500" />;
//   if (trend < 0)
//     return <Icon name="arrowdown" className="h-4 w-4 text-red-500" />;
//   return null;
// }

// function TrendIndicator({ trend }: { trend: number }): JSX.Element {
//   return (
//     <span className={`text-sm ${getTrendColor(trend)} flex items-center gap-1`}>
//       {getTrendIcon(trend)}({Math.abs(trend)}%)
//     </span>
//   );
// }

function formatCheckInStats(data: CheckInData): JSX.Element {
  const didMissSessionCheckins =
    data?.total !== 0 && ((data.count || 0) / (data.total || 1)) * 100 < 90;
  return (
    <div className={`flex items-center gap-1 `}>
      {data.count !== undefined && data.total !== undefined ? (
        <span
          className={`w-28 text-center rounded-sm ${
            didMissSessionCheckins ? 'bg-red-100' : 'bg-white'
          }`}
        >
          {data.count > data.total ? data.total : data.count}/{data.total}
          {/* <span className=" text-gray-500"> ({data.percentage}%)</span> */}
        </span>
      ) : (
        <span>{data.percentage}%</span>
      )}
      {/* {data?.trend !== undefined && data.trend !== 0 && (
        <TrendIndicator trend={data.trend} />
      )} */}
    </div>
  );
}

export const TEAM_MEMBER_STATS_COLUMNS: Column<TeamMemberStats>[] = [
  {
    key: 'name',
    title: 'Team Member',
    render: (item: TeamMemberStats) => item.name,
  },
  {
    key: 'averageCheckIns',
    title: 'Average Check-Ins %',
    render: (item: TeamMemberStats) =>
      formatCheckInStats({
        percentage: item.averageCheckIns.percentage,
        // trend: item.averageCheckIns.trend,
      }),
  },
  {
    key: 'midDayCheckIns',
    title: 'Mid-Day Check-Ins',
    render: (item: TeamMemberStats) =>
      formatCheckInStats({
        count: item.midDayCheckIns.count,
        total: item.midDayCheckIns.total,
        // percentage: item.midDayCheckIns.percentage,
      }),
  },
  {
    key: 'dayEndCheckIns',
    title: 'Day-End Check-Ins',
    render: (item: TeamMemberStats) =>
      formatCheckInStats({
        count: item.dayEndCheckIns.count,
        total: item.dayEndCheckIns.total,
        // percentage: item.dayEndCheckIns.percentage,
      }),
  },
];
